import { SavedItemsState } from "../../redux";

export const isItemInFavorites = (savedItems: SavedItemsState) => (docId: string) => savedItems.data.find(x => x === docId)